import { create } from 'zustand';
import { useEffect } from 'react';
import { authClient } from '@/lib/auth-client';

type AuthUser = {
  id: string;
  email: string;
  name?: string | null;
  image?: string | null;
  role?: string;
};

type AuthState = {
  isLoading: boolean;
  isAuthenticated: boolean;
  user: AuthUser | null;
  refresh: () => Promise<void>;
};

export const useAuth = create<AuthState>((set) => ({
  isLoading: true,
  isAuthenticated: false,
  user: null,
  refresh: async () => {
    try {
      const session = await authClient.getSession();
      if (session.data) {
        set({
          isLoading: false,
          isAuthenticated: true,
          user: session.data.user as AuthUser,
        });
      } else {
        set({ isLoading: false, isAuthenticated: false, user: null });
      }
    } catch {
      set({ isLoading: false, isAuthenticated: false, user: null });
    }
  },
}));

export const useAuthBootstrap = () => {
  const refresh = useAuth((s) => s.refresh);
  useEffect(() => {
    void refresh();
  }, [refresh]);
};
